import { useContext } from "react";
import { PinnableItemsContext } from "./PinnableItemsProvider";

export const usePinnableItems = () => {
  const context = useContext(PinnableItemsContext);
  if (!context) {
    throw new Error("useSelectableItems must be used within a SelectableItemsProvider");
  }
  return context;
};
